import React from 'react';
import { RawIntlProvider } from 'react-intl';
import { observer } from 'mobx-react';
import localeStore from './common/store/LocaleStore';

const IntlContainer = ({ children }: React.PropsWithChildren<{}>) => !localeStore.intl ? null : (
  <RawIntlProvider value={localeStore.intl}>{children}</RawIntlProvider>
);

export default observer(IntlContainer);
